import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropDownMenuComponent } from './drop-down-menu.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';



@NgModule({
    declarations: [
        DropDownMenuComponent
    ],
    imports: [
        CommonModule,
        SvgIconModule
    ],
    exports: [
        DropDownMenuComponent
    ]
})
export class DropDownMenuModule { }
